/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TPNProgressBar_tradeFirm$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PointsSummary_tradeFirm$ref: FragmentReference;
export type PointsSummary_tradeFirm = {|
  +loyalty: ?{|
    +currentYearSpend: ?{|
      +amount: ?number
    |}
  |},
  +rewards: ?{|
    +currentProgram: ?{|
      +minPoints: ?number,
      +programInfo: ?{|
        +code: ?string,
        +displayName: ?string,
      |},
    |},
    +nextProgram: ?{|
      +minPoints: ?number,
      +programInfo: ?{|
        +displayName: ?string
      |},
    |},
  |},
  +$fragmentRefs: TPNProgressBar_tradeFirm$ref,
  +$refType: PointsSummary_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "minPoints",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PointsSummary_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "loyalty",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmLoyaltyType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "currentYearSpend",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "rewards",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmRewards",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "currentProgram",
          "storageKey": null,
          "args": null,
          "concreteType": "ParentProgram",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "programInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "code",
                  "args": null,
                  "storageKey": null
                },
                (v1/*: any*/)
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "nextProgram",
          "storageKey": null,
          "args": null,
          "concreteType": "ParentProgram",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "programInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "TPNProgressBar_tradeFirm",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a1b51f0d14d43061f2c523c52003aaaf';
module.exports = node;
